// extracted by mini-css-extract-plugin
module.exports = {"app":"Home_app__1BJya","story_wrapper":"Home_story_wrapper__2Xxh-","next":"Home_next__20yCQ","hide":"Home_hide__CiA5B","previous":"Home_previous__3_wRs"};